export default {
  methods(http) {
    return {
      get: () => http.get.success('/api/v1/config', { skipAuthentication: true }),
    };
  },
};
